import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PendingPaymentDetail from 'components/Tvendo/Bank/Operations/Payments/PendingPaymentDetail/PaymentRDoc';
import NewPayment from 'components/Tvendo/Bank/Operations/Payments/PendingPaymentDetail/NewPayment';

export default function () {
  const { pathname } = useLocation();

  const [DefaultDocType, paymentType] = useMemo(() => {
    if (pathname.includes('pago-recibidos')) return ['C', 'RECEIVED'];
    return ['S', 'ACCOMPLISHED'];
  }, [pathname]);

  // return <PendingPaymentDetail />;
  return <NewPayment DefaultDocType={DefaultDocType} paymentType={paymentType} />;
}
